import { useState } from "react";
import { cn } from "../../lib/utils";
import { PageNavigationContext } from "./PageNavigation";
import "./form-page.css";

/** Keep Back navigation at the page edge and form content centered below it. */
export function FormPage({ size = "standard", children, className }) {
  const [navigationTarget, setNavigationTarget] = useState(null);
  const variant = ["standard", "compact", "wide"].includes(size) ? size : "standard";
  return (
    <PageNavigationContext.Provider value={navigationTarget}>
      <div className="form-page-navigation" ref={setNavigationTarget} />
      <div className={cn("form-page", `form-page--${variant}`, className)}>
        {children}
      </div>
    </PageNavigationContext.Provider>
  );
}